<template xmlns="http://www.w3.org/1999/html">
  <section class="section mobile_div section_bg container-fluid" >
    <loading-block v-if="is_load==false" :loading="!is_load"/>

      <div class="section_header mobile_div  d-flex justify-content-center   " v-if="is_load==true && ((project && project.status_row && project.status_row.issearch==0) || type=='client')">

        <router-link v-if="project.status_row.issearch==1" tag="a" class="btn" :to="{name: 'home'}"  ><i class="fa fa-backward"></i> Назад</router-link>
        <router-link v-if="project.status_row.issearch==0 && project.main_project_id==0" tag="a" class="btn" :to="{name: 'home'}"  ><i class="fa fa-backward"></i> Назад</router-link>
        <router-link v-if="project.status_row.issearch==0 && project.main_project_id>0" tag="a" class="btn" :to="{name: 'project', params: { id: project.main_project_id }}"  ><i class="fa fa-backward"></i> Назад</router-link>

      </div>

    <div class="section_header mobile_div  d-flex justify-content-center   " v-if="is_load==true && (project.status_row.issearch==1 && type=='developer') ">

      <router-link tag="a" class="btn" :to="{name: 'freelance_tasks'}"  ><i class="fa fa-backward"></i> Назад</router-link>

    </div>


     <div class=" mt-4" v-if="is_load">







       <div class="" v-if="project.status_row.issearch==1">
         <div class="section_header nocenter mobile_div_new ">

         <p v-if="project.category_id>0 && project.service && project.service.name">
           <b>Услуга</b> {{ project.service.name}}
         </p>
         <p v-if="project.datetime_client">
           <b>Дата записи</b> {{ project.datetime_client }}
         </p>

         <editorjsrender :blocks_json="project.json.blocks" ></editorjsrender>


             <div class="col-12 col-md-6 col-lg-5">
               <user-card :user="project.client"/>
             </div>



         <div class="col-12 ml-2 mt-5"
             v-if="(project.client_id==me.last_id || (project.status_row.issearch==0 && type=='developer')) || ( (project.main_project && project.main_project.manage_spectator==1) || (project && project.manage_spectator==1) )">

           <router-link v-if="project.main_project_id==0" tag="a" class="btn" :to="{name: 'edit_project',params:{'id':project.last_id}}">
             Редактировать<br> проект
           </router-link>

           <router-link v-if="project.main_project_id>0" tag="a" class="btn" :to="{name: 'edit_project',params:{'id':project.last_id}}">
             Редактировать<br> задачу
           </router-link>

         </div>
         </div>

         <div class="">
           <div class="col-12 d-flex justify-content-center">
             <h3  class="text-center">Заявки от исполнителей</h3>
           </div>


           <div class="col-md-12 center-block mt-5" v-if="project.status_row.issearch==1">

             <div class="section_header nocenter mobile_div row   ml-4 "v-if="project.offers.length==0 && type!='client'">
               <FormPriceBlock  :is_start_send="is_send_offer"  @click_button="(changed_offer) => {
                  newOffer=changed_offer;
                  sendOffer();
                } "     :newOffer="newOffer" :new_offer_is_error="new_invoice_iserror" :type_currencys="type_currencys" :new_offer_error="new_invoice_error"/>
             </div>
             <div class="section_header nocenter mobile_div row  ml-4 d-flex justify-content-center" v-for="(offer,offer_index) in project.offers" :key="offer.last_id">
               <FreelanceBlock v-if="( type=='client')" @click_choose_developer="(val)=>{ ChooseOffer(offer.last_id); }" @click_developer="(val)=>{ showEditFreelanceBlock(); }" :isDeveloper="(me.last_id==offer.developer_id)" :isClient="(parseInt(me.last_id)==parseInt(project.client_id))"  :offer="offer"/>
               <FormPriceBlock v-if="(me.last_id==offer.developer_id) " :is_start_send="is_send_offer"  @click_button="(changed_offer) => {
                  newOffer=changed_offer;
                  sendOffer();
                } "     :newOffer="newOffer" :new_offer_is_error="new_invoice_iserror" :type_currencys="type_currencys" :new_offer_error="new_invoice_error"/>
               <div class="col-12"   v-if="(me.last_id==offer.developer_id || type=='client')"
               >
                 <CommentBlock  v-for="(offer_comment,index_offer_comment) in offer.comments"  :comment="offer_comment" :isSubcomment="1"  :key="offer_comment.last_id"/>
                 <FormCommentBlock  :isSubcomment="0" :is_start_send="subcomment_send['offer'+offer.last_id]"  :comment_text="subcomment['offer'+offer.last_id]"

                     @click_button="(comment_text) => {


                  sendOfferComment(offer.last_id,offer_index,comment_text)

                } "  :user="me"/>
               </div>

             </div>


           </div>
         </div>

       </div>
        <div class="" v-if="project.status_row.issearch==0">



          <div class="row">

            <div :class="{'col-md-8 col-lg-8':(!(project.service && project.service.is_disable_full_functions && project.service.is_disable_full_functions==1)),'col-md-12 col-lg-12':(project.service && project.service.is_disable_full_functions && project.service.is_disable_full_functions==1)}" class="col-12 ">

              <div class="section_header nocenter mobile_div_new" v-if="current_page=='project'">
                <p v-if="(project.service && project.service.is_disable_full_functions && project.service.is_disable_full_functions==1)" >
                  <router-link    tag="a" class="btn" :to="{name: 'project_list_invoices', params: { id: project.last_id }}">
                    Счета
                    <badge v-if="project.invoices_count>0" type="white">{{ project.invoices_count }}</badge>
                  </router-link>
                </p>
                <p v-if="(project.service && project.service.is_disable_full_functions && project.service.is_disable_full_functions==1)">
                  <a href="javascript:void(0)"    @click="modals.users = true" class="btn"  >Участники</a>
                </p>
                <p v-if="project.category_id>0 && project.service && project.service.name">
                  <b>Услуга</b> {{ project.service.name}}
                </p>




                <p v-if="project.datetime_client">
                  <b>Дата записи</b> {{ project.datetime_client }}
                </p>
                <h4 class="mt-2 mb-2" v-if="project.status_row.issearch==0 && project.main_project ">ID:{{ project.last_id }}</h4>
                <div class="mt-2 mb-2">
                  <select   class="form-control" @change="setNewStatus" v-model="project.status"
                      v-if="project.statuses.length>0 && (type!='spectator' || (project.manage_spectator==1) || (project.main_project && project.main_project.manage_spectator==1)) && project.developer_id>0 && is_load_new_status==true">
                    <option v-for="status in project.statuses"
                        :value="status.last_id" :key="status.last_id">
                      {{ status.title }}

                    </option>

                  </select>
                </div>

                <editorjsrender :blocks_json="project.json.blocks" ref="contentArticle"></editorjsrender>

                <div class=" mt-5"
                     v-if="(project.client_id==me.last_id || (project.status_row.issearch==0 && type=='developer')) || ( (project.main_project && project.main_project.manage_spectator==1) || (project && project.manage_spectator==1) )">
                  <button class="btn btn-sm mt-2" @click="exportPDF()"><i class="fa fa-file-pdf-o"></i></button>
                  <router-link v-if="project.main_project_id==0 && !((type!='developer' ) && (project.service && project.service.is_disable_full_functions && project.service.is_disable_full_functions==1))" tag="a" class="btn btn-sm mt-2" :to="{name: 'edit_project',params:{'id':project.last_id}}">
                    Редактировать
                  </router-link>

                  <router-link v-if="project.main_project_id>0" tag="a" class="btn btn-sm mt-2 " :to="{name: 'edit_project',params:{'id':project.last_id}}">
                    Редактировать
                  </router-link>

                  <button v-if="project.main_project_id>0 && relations_type && relations_type.length>0" @click="modals.modal_link = true" class="btn btn-sm mt-2">
                    Добавить связь
                  </button>



                </div>


              </div>
              <div class="row-grid ml-2 mt-5" v-if="current_page=='map'">
                <div class="col-md-12 center-block"  >
                  <h2>Карта сайта</h2>
                  <vue-suggestion placeholder="Введите запрос для поиска задачи" inputClasses="form-control" :items="map_items"
                                  v-model="map_item"
                                  :setLabel="setMapLabel"
                                  :itemTemplate="itemTemplate"
                                  @changed="inputMapChange"
                                  @selected="itemMapSelected">
                  </vue-suggestion>
                  <div class="row col-lg-12">
                    <div class="col-12 col-lg-3">
                      <p v-if="!(map_current_task && map_current_task.id)">выберите задачу</p>
                      <p v-if="(map_current_task && map_current_task.id)">{{ map_current_task.name}}</p>
                    </div>
                    <div class="col-12 col-lg-6">
                      <textarea v-model="map_current_descr" placeholder="введите описание"></textarea>
                    </div>
                    <div class="col-12 col-lg-3">
                      <button class="btn " v-if="map_current_descr.length>0 && map_current_task && map_current_task.id" @click="addTaskOnMap">Добавить</button>
                    </div>
                  </div>



                  <simple-flowchart     :scene.sync="data_map"></simple-flowchart>
                  <div class="row">
                    <div class="col-12 col-lg-4 mt-4">
                      <button class="btn" @click="saveMap">Сохранить карту</button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row-grid section_header nocenter  mobile_div_new mt-5" v-if="current_page=='tasks'">
                <div  class="section_black mobile_div second_section">

                  <div class="col-md-12 center-block" v-if="is_load_tasks==false">
                   <h2>Идет загрузка...</h2>
                  </div>


                  <div class="col-md-12 mobile_div center-block" v-if="is_load_tasks==true">

                    <div class="col-12">
                      <p class="text-center">{{ tasks_list.next_offset}} /{{ tasks_list.count }}</p>
                    </div>
                    <div class="row mt-5 mb-5  d-flex justify-content-center">
                      <div class="col-md-5">
                        <input type="text" class="mt-2 form-control" placeholder="Введите для поиска" @change="changeFilterTasks(0)" v-model="filter_tasks.q"/>
                      </div>
                      <div class="col-md-5">
                        <select class="form-control mt-2" @change="changeFilterTasks(0)" v-model="filter_tasks_current_status">
                          <option :value="null">Показать все</option>
                          <option v-if="project.statuses.length>0" v-for="status in project.statuses" :value="status.last_id"
                                  :key="status.last_id">{{
                              status.title
                            }}
                          </option>
                        </select>
                      </div>
                    </div>



                    <div class="col-lg-12 mobile_div" v-if="tasks.length>0">

                      <ProjectCard :project="task" class="inner_div_block"
                                   v-for="(task,task_index) in tasks" :key="task.last_id"/>



                      <div class="row mt-2 text-center">
                        <div class="col-6  " >

                          <button v-if=" tasks_list.count>0 && tasks_list.offset>0" @click="prevBtnTasksList" class="btn">Назад</button>
                          <button v-if="!( tasks_list.count>0 && tasks_list.offset>0)" disabled   class="btn disabled">Назад</button>
                        </div>

                        <div class="col-6  " >
                          <button @click="nextBtnTasksList" v-if="tasks_list.count>tasks_list.next_offset" class="btn">Вперед</button>
                          <button   v-if="!(tasks_list.count>tasks_list.next_offset)" disabled class="btn ">Вперед</button>
                        </div>


                      </div>


                    </div>

                  </div>
                </div>
              </div>
              <div class="row-grid section_header nocenter  mobile_div_new mt-5" v-if="current_page=='canban'">

                <h2> Канбан-доска</h2>



                <div class="row">
                  <div class="col-lg-12 row">

                    <div class="row col-lg-6">


                      <input type="text" class="m-2 form-control" placeholder="Введите для поиска"  v-model="searchfields['q']"/>

                    </div>
                    <div class="row col-lg-6">
                      <select class="m-2 form-control"  v-model="searchfields['_type']">
                        <option value="null">Выберите тип</option>
                        <option value="projects">Проекты</option>
                        <option value="tasks">Задачи</option>
                        <option value="all">Проекты и задачи</option>

                      </select>
                    </div>
                  </div>
                  <div  class="col-lg-12 row"    v-if="fields   && fields.length>0">



                    <div class="row col-lg-6  form-group"  v-for="field in fields"   :key="field.last_id">
                      <div class="col-md-6">
                        <label for="exampleCategory">{{ field.title}} </label>
                      </div>
                      <div class="col-md-6">
                        <select  id="exampleCategory" v-if="field.type=='select' || field.type=='selectinsert'" v-model="searchfields[field.name]"

                                 class="form-control">
                          <option value="null"></option>
                          <option v-for="value in field.values" :value="value.last_id" :key="value.last_id">
                            {{ value[field.key_title] }}
                          </option>

                        </select>
                        <select  id="exampleCategory" v-if="field.type=='selectteam'" v-model="searchfields[field.name]"

                            class="form-control">
                          <option value="null"></option>
                          <option v-for="user_team in field.users" :value="user_team.last_id" :key="user_team.last_id">
                            {{ user_team.name }}
                          </option>

                        </select>
                        <input class="form-control" type="number" v-if="field.type=='number'" v-model="searchfields[field.name]"/>
                        <input class="form-control" type="text" v-if="field.type=='stroka'" v-model="searchfields[field.name]"/>
                      </div>






                    </div>

                  </div>
                  <div class="col-lg-12 form-group">
                    <button class="btn" @click="searchFilter()">Найти</button>




                  </div>


                </div>


                <div class="row" v-if="stages.length>0">

                  <kanban-board  @update-block="updateBlock" :stages="stages" :blocks="blocks"> <div v-for="stage in stages" :slot="stage" :key="stage" >
                    <h2>{{ stage }}</h2>
                  </div>

                    <div class="card lead_mini" style="" v-for="block in blocks" :slot="block.id" :key="block.id" >

                      <div class="card-body lead_info overflow-hidden">

                        <badge pill type="warning" @click="openProject(block.project.main_project.last_id)" v-if="block.project.main_project && block.project.main_project.name_project && block.project.main_project.name_project.length>0">[{{ block.project.main_project.name_project}}]
                        </badge><br>
                        <p class="lead" @click="openProject(block.id)"  v-if="block.project.name_project && block.project.name_project.length>0">{{ block.project.name_project}}</p>

                        <div class="row">

                          <div class="col-8">

                            <div v-if="fields.length>0" v-for="field in fields"  :key="block.id">
                              <p v-if='block.project.custom_fields && block.project.custom_fields[field.name] && !(block.project.custom_fields[field.name+"_title"])'><badge type="success">{{ field.title}}</badge> {{ block.project.custom_fields[field.name] }}</p>
                              <p v-if='block.project.custom_fields  && (block.project.custom_fields[field.name+"_title"])'><badge type="success">{{ field.title}}</badge> {{ block.project.custom_fields[field.name+'_title'] }}</p>

                            </div>


                          </div>
                          <div class="col-4">
                            <img class="img img-thumbnail" :src="image_url+block.project.developer.avatar"/>



                          </div>
                        </div>

                        <div class="row mt-2">
                          <div class="col-4">
                            <div class="mt-2">
                              <router-link tag="a"  :to="{name: 'project',params:{id:block.project.last_id}}">
                                <badge type="default">#{{block.project.last_id}}</badge>
                              </router-link>

                            </div>
                          </div>
                          <div class="col-8">
                            <div>
                              <router-link tag="a" class="btn"  :to="{name: 'project',params:{id:block.project.last_id}}">Открыть</router-link>

                            </div>
                          </div>
                        </div>



                      </div>

                    </div>
                  </kanban-board>
                </div>






              </div>

            </div>
            <div class="col-12 col-md-4 col-lg-4 text-center " v-if="!(project.service && project.service.is_disable_full_functions && project.service.is_disable_full_functions==1)">
              <div class="d-flex justify-content-center">
              <div class="section_no_background projectmenu mobile_div_new  ">



                <p v-if="project.statuses.length>0 && (type!='spectator' || (project.manage_spectator==1) || (project.main_project && project.main_project.manage_spectator==1)) && project.developer_id>0 && is_load_new_status==false">сохранение..</p>

                <p v-if="type=='spectator' && !(project.manage_spectator==1) &&  !(project.main_project && project.main_project.manage_spectator==1)">{{ project.status_row.title }}</p>

                <ul class="nav navbar flex-column">
                  <li v-if="project.main_project_id==0">
                    <a :class="{'btn-active':(current_page=='project')}" href="javascript:void(0);"    @click="openCurrentPageProject">Проект</a>
                  </li>
                  <li v-if="project.main_project_id>0">
                    <a href="javascript:void(0);" :class="{'btn-active':(current_page=='project')}"     @click="openCurrentPageProject">Задача</a>

                  </li>

                  <li v-if="project.main_project_id==0 && project.status_row.issearch==0">
                    <a href="javascript:void(0);" :class="{'btn-active':(current_page=='canban')}"     @click="openCurrentPageCanban">Канбан-Доска</a>

                  </li>
                  <li v-if="project.main_project_id==0 && project.status_row.issearch==0">
                    <a href="javascript:void(0);" :class="{'btn-active':(current_page=='tasks')}"    @click="openCurrentPageTasks">Все задачи</a>

                  </li>

                </ul>




                <ul class="nav navbar flex-column">

<!--                  <li   v-if="(type=='developer' || type=='client') && project.status_row.issearch==0 && project.manage_spectator==0 && project.main_project_id==0 ">-->
<!--                    <a  class="btn"    @click="changeManageSpectator(1)"  >общий доступ включить</a>-->
<!--                  </li>-->



                  <li v-if="project.status_row.issearch==0 && project.main_project_id==0 && (type!='spectator' || (  project.manage_spectator==1 && project.main_project_id==0)) ">  <router-link  tag="a"  href="javascript:void(0);" @click="preventClick"  :to="{name: 'add_task',params:{id:project.last_id}}">
                    Добавить задачу
                  </router-link></li>

<!--                  <li   v-if="(type=='developer' || type=='client') && project.status_row.issearch==0 && project.manage_spectator==1 && project.main_project_id==0 ">-->
<!--                    <a     class="btn" @click="changeManageSpectator(0)" >общий доступ выключить</a>-->
<!--                  </li>-->
                  <li   v-if="(project.status_row.issearch==0 && type!='spectator') && !(project.main_project && project.main_project.manage_spectator==1)">
                    <a href="javascript:void(0)"    @click="modals.users = true"  >Участники</a>
                  </li>
                  <li   v-if="(project.status_row.issearch==0 && project.main_project_id==0)">
                    <router-link     tag="a" :to="{name: 'project_list_invoices', params: { id: project.last_id }}">
                      Счета
                      <badge v-if="project.invoices_count>0" type="white">{{ project.invoices_count }}</badge>
                    </router-link>
                  </li>
                  <li v-if="(type=='developer' || type=='client' || type=='spectator') && project.status_row.issearch==0 && project.main_project_id==0">
                    <router-link     tag="a" :to="{name: 'list_articles', params: { id: project.last_id }}">
                      База знаний
                    </router-link>

                  </li>


                  <li  v-if="(type=='client' || type=='developer') && project.secretId && project.status_row.issearch==0 && project.main_project_id==0 && me.telegram_id && me.telegram_id>0 && telegram_bot">
                    <a  href="javascript:void(0)"     @click="modals.modal_integration_telegram = true">Интеграция с TG</a>
                  </li>
                  <li  v-if="( type=='developer') && lead && lead.id">
                    <a  href="javascript:void(0)"     @click="openLead(lead.id)">Сделка</a>
                  </li>





                </ul>
              </div>
              <!--            <card class="mt-2" v-if=" project.main_project_id==0 && project.manage_spectator==1 && guest_token   ">-->
              <!--              <div class="mt-2 card-header">-->
              <!--                <p><strong>Гостевой доступ</strong> </p>-->
              <!--                <p><textarea class="form-control">{{ base_url+'project/'+project.last_id+'?api='+guest_token }}</textarea></p>-->
              <!--              </div>-->
              <!--            </card>-->


              </div>
              <div class="section_header" v-if="project.main_project_id>0 && ( ( project.main_project_id>0 && project.main_project.manage_spectator==1 && project.developer) || (project && project.status_row.issearch==0 && project.fields && project.fields.length>0 && project.custom_fields!=null) )">
                <div class="mt-2 p-2 " v-if=" project.main_project_id>0 && project.main_project.manage_spectator==1 && project.developer  ">
                  <p><router-link :to="{name: 'user_page_main', params: { user_id: project.developer.last_id }}"><strong>Исполнитель</strong> {{ project.developer.name}}</router-link></p>
                </div>
                <div class="mt-2 p-2 " v-if=" project.main_project_id>0 && project.main_project.manage_spectator==1 && project.client  ">
                  <p><router-link :to="{name: 'user_page_main', params: { user_id: project.client.last_id }}"><strong>Ответственный</strong> {{ project.client.name}}</router-link></p>
                </div>

                <div class=" mt-2" v-if="project && project.status_row.issearch==0 && project.fields && project.fields.length>0 && project.custom_fields!=null">
                  <div class="mt-2 p-2" v-if="project.custom_fields[field.name]"  v-for="(field,field_index) in project.fields" :key="field_index">
                    <p v-if="field.type!='select' && field.type!='selectteam'  "><strong>{{ field.title}}:</strong> {{ project.custom_fields[field.name]}}</p>
                    <p v-if="field.type=='select' && project.custom_fields[field.name+'_title']"><strong>{{ field.title}}:</strong> {{ project.custom_fields[field.name+'_title']}}</p>
                    <p v-if="field.type=='selectteam' && project.custom_fields[field.name+'_title']"><strong>{{ field.title}}:</strong>  <router-link   tag="a"
                        :to="{name: 'user_page_main', params: { user_id: project.custom_fields[field.name]}}" >{{ project.custom_fields[field.name+'_title']}}</router-link></p>
                    <p v-if="field.type=='selectteam' && !project.custom_fields[field.name+'_title']"><strong>{{ field.title}}:</strong> Не указан</p>
                  </div>
                </div>
              </div>
            </div>




            <div class="col-12 second_section " v-if="project.status_row.issearch==0 && current_page=='project' && relations && relations.length>0">
              <div class="col-md-12 center-block mt-5" ref="links_tasks" v-if="project.status_row.issearch==0 && current_page=='project'">
                <h3 >Связи</h3>

                <div class="row ml-4"   v-for="(relation,relation_index) in relations" :key="relation.id">

                  <badge class="badge badge-info" v-if="project.last_id==relation.parent_task.last_id">
                    {{ relation.relation.relation_to_children }}
                  </badge>

                  <badge class="badge badge-info" v-if="project.last_id==relation.children_task.last_id">
                    {{ relation.relation.relation_to_parent }}
                  </badge>

                  <b v-if="project.last_id==relation.parent_task.last_id">&nbsp;&nbsp;<router-link tag="a"  :to="{name: 'project',params:{'id':relation.children_task.last_id}}">{{ relation.children_task.name_project }}</router-link>  <badge class="badge badge-info"> {{ relation.children_task.status_row.title }} </badge></b>
                  <b v-if="project.last_id==relation.children_task.last_id">&nbsp;&nbsp;<router-link tag="a"  :to="{name: 'project',params:{'id':relation.parent_task.last_id}}">{{ relation.parent_task.name_project }}</router-link>  <badge class="badge badge-info"> {{ relation.parent_task.status_row.title }} </badge></b>
                  &nbsp;&nbsp;<button class="btn btm-sm" @click="removeLink(relation.id)"><i class="fa fa-remove"></i></button>
                </div>

              </div>

            </div>
            <div class="col-12 " v-if="project.status_row.issearch==0 && current_page=='project'">
             <div class="section_header nocenter mobile_div_new  ">
               <h3 >История изменений</h3>
               <div class="row ml-4"   v-for="(comment,comment_index) in history" :key="comment.last_id">
                 <CommentBlock v-if="comment.type_object=='comment'" :comment="comment"/>
                 <div class="col-12">
                   <CommentBlock  v-if="comment.comments && comment.comments.length>0" v-for="(subcomment,subcomment_index) in comment.comments" :key="subcomment.last_id" :comment="subcomment" :isSubcomment="1"/>
                   <FormCommentBlock :isSubcomment="1" v-if="comment.type_object=='comment'" :is_start_send="is_send_comments['comment_'+comment.last_id]"  :comment_text="project_subcomment['comment' + comment_id]"

                       @click_button="(subcomment_text) => {
                  project_subcomment['comment' + comment.last_id]=subcomment_text;
                  sendSubComment(comment.last_id,comment_index)
                } "  :user="me"></FormCommentBlock>
                 </div>
                 <StatusHistoryProjectBlock v-if="comment.type_object=='status_history'" :comment="comment"/>

               </div>
               <div class="clearfix"></div>
               <div class="alert alert-danger" v-if="iserror==true">
                 <p>{{ error_message }}</p>
               </div>

               <FormCommentBlock :user="me" :isCanEditorJs="true" :is_start_send="is_send_comment"  :comment_text="newComment.comment"  @click_button="(comment_text) => {

                  is_send_comment=0;
                  newComment.comment=comment_text;
                  sendComment()
                } " />

             </div>






            </div>
          </div>


        </div>




        <modal modal-classes="modal-lg" :show.sync="modals.modal_integration_telegram">
          <template slot="header">
            <h5 class="modal-title" id="exampleModalLabel5">Интеграция с Telegram</h5>
          </template>
          <div class=""  v-if="telegram_bot" >



            <ul style="text-align: left;">
              <li>Шаг 1. Создайте группу</li>
              <li>Шаг 2. Пригласите бота <a :href="'https://t.me/'+telegram_bot">@{{telegram_bot}}</a> в группу</li>
              <li>Активируйте бота ,написав в группе сообщение:</li>
              <li><textarea class="form-control" readonly>/addgroup {{ project.secretId}}</textarea></li>
            </ul>
            <p v-if="matrix_status==true"><strong>Matrix.org</strong></p>
            <ul  v-if="matrix_status==true" style="text-align: left;">

              <li>Шаг 1. Создайте комнату</li>
              <li>Шаг 2. Пригласите бота Добавьте бота в комнату <a :href="'https://matrix.to/#/'+matrix_bot" target="_blank">{{ matrix_bot}}</a> в комнату</li>
              <li>Активируйте бота ,написав в группе сообщение:</li>
              <li><textarea class="form-control" readonly>addgroup {{ project.secretId}}</textarea></li>
            </ul>




          </div>
          <template slot="footer">
            <base-button type="secondary" @click="modals.modal_integration_telegram = false">Закрыть</base-button>

          </template>
        </modal>
        <modal modal-classes="modal-lg"  :show.sync="modals.add">
          <template slot="header">
            <h5 class="modal-title" id="exampleModalLabel">{{ modal_title }}</h5>
          </template>
          <div>
            <div class="alert alert-danger" v-if="iserror==true">
              <p>{{ error_message }}</p>
            </div>

            <div class="form-group row" v-if="type=='developer' && is_add_task">
              <label for="exampleUser">Исполнитель задачи</label>
              <select id="exampleUser" v-if="is_load==true" required v-model="new_task_developer"
                      class="form-control">
                <option value="me">Я</option>

                <option v-if="user.last_id!=me.last_id && user.isapprove==1 && user.role=='spectator'" v-for="user in users"
                        :value="user.last_id"
                        :key="user.last_id">@{{
                    user.name
                  }}
                </option>

              </select>


            </div>


          </div>
          <template slot="footer">
            <base-button type="secondary" @click="modals.add = false">Close</base-button>
            <base-button @click="doEditProject" >Сохранить</base-button>
          </template>
        </modal>

       <modal :show.sync="modals.modal_link" >
         <template slot="header">
           <h5 class="modal-title" id="exampleModalLabel2">Добавить связь</h5>
         </template>
         <div>
           <div class="alert alert-danger" v-if="new_link_iserror==true">
             <p>{{ new_link_error }}</p>
           </div>

           <div class="row">
             <div class="form-group col-8">

              <input type="text" class="form-control" v-model="newLink.title_task" placeholder="Введите название задачи"/>

             </div>

             <div class="form-group col-4">
               <button class="btn btn-sm mt-2 mb-2" @click="searchTasksLink()"><i class="fa fa-search"></i></button>
             </div>



           </div>
           <div class="row" v-for="task_link in links_founded_tasks"
               :key="task_link"  v-if="links_founded_tasks && links_founded_tasks.length>0">
              <p>{{ task_link.name_project }}</p>
              <button class="btn btn-sm" @click="insertTaskIdToLink(task_link.last_id)">Вставить</button>
           </div>
           <div class="row">
             <div class="form-group col-md-5">
               <label for="exampleUser">Отношение</label>
               <select id="exampleUser"  required v-model="newLink.relation_id"
                   class="form-control">
                 <option
                     v-for="relation_type in relations_type" :value="relation_type.id"
                     :key="relation_type.id">{{
                     relation_type.title
                   }}
                 </option>

               </select>


             </div>
             <div class="form-group col-md-5">
               <label for="exampleTypeInvoice">ID Задачи </label>
               <input class="form-control" type="number" v-model="newLink.task_id"/>



             </div>
           </div>



         </div>
         <template slot="footer">
           <base-button type="secondary" @click="modals.modal_link = false">Закрыть</base-button>
           <base-button   @click="addLink()">Создать связь</base-button>
         </template>
       </modal>
        <modal :show.sync="modals.modal0" v-if="type=='developer' && (project.developer_id==me.last_id ) && project.main_project_id=='0'">
          <template slot="header">
            <h5 class="modal-title" id="exampleModalLabel2">Добавить счет</h5>
          </template>
          <div>
            <div class="alert alert-danger" v-if="new_invoice_iserror==true">
              <p>{{ new_invoice_error }}</p>
            </div>
            <div class="row">
              <div class="form-group col-md-12">
                <label for="exampleUser">Пользователь </label>
                <select id="exampleUser" v-if="is_load==true" required v-model="newInvoice.user_id"
                        class="form-control">
                  <option v-if="user.last_id!=me.last_id || (user.role=='spectator' && user.isapprove==0)"
                          v-for="user in users" :value="user.last_id"
                          :key="user.last_id">@{{
                      user.name
                    }}
                  </option>

                </select>


              </div>

            </div>
            <div class="row">
              <div class="form-group col-6 col-md-5">
                <label for="exampleSum">Сумма </label>
                <input type="text" class="form-control" required id="exampleSum" v-model="newInvoice.sum"
                       placeholder="Введите сумму">

              </div>
              <div class="form-group col-6 col-md-5">
                <label for="exampleSum">Предоплата </label>
                <input type="text" class="form-control" required id="exampleSum" v-model="newInvoice.prepaid_sum"
                    placeholder="Введите сумму предоплаты">

              </div>

            </div>
            <div class="row">
              <div class="form-group col-6 col-md-5">
                <label for="exampleTypeInvoice">Тип </label>
                <select id="exampleTypeInvoice" v-if="is_load==true" required
                    class="form-control" v-model="newInvoice.type">
                  <option value="client" >
                    должен
                    оплатить
                  </option>
                  <option value="developer" >
                    должен получить
                  </option>
                </select>


              </div>
              <div class="form-group col-6 col-md-5">
                <label for="exampleCurrency5">Валюта </label>
                <select id="exampleCurrency5" v-if="is_load==true" required
                    class="form-control" v-model="newInvoice.currency">
                  <option v-for="(current_currency,currency_index) in type_currencys"
                      :value="current_currency" :key="currency_index">
                    {{ current_currency }}

                  </option>

                </select>


              </div>
            </div>
            <div class="row">
              <div class="col-6">
                <select id="currency" class="form-control" v-model="newInvoice.type_pay">
                  <option :value="'one'">единоразовая</option>
                  <option :value="'every_month'">раз в месяц</option>
                  <option :value="'every_year'">раз в год</option>
                </select>
              </div>
              <div class="col-6">
                <input type="text" class="form-control" required id="exampleTitle5" v-model="newInvoice.title"
                    placeholder="Введите описание">
              </div>

            </div>
          </div>
          <template slot="footer">
            <base-button type="secondary" @click="modals.modal0 = false">Закрыть</base-button>
            <base-button   @click="addInvoice()">Создать счет</base-button>
          </template>
        </modal>
        <modal v-if="project.status_row.issearch==0 && type!='spectator'" :show.sync="modals.users">
          <template slot="header">
            <h5 class="modal-title">Список участников</h5>
          </template>
          <div>
            <div class=" col-12 col-sm-12 col-md-12 col-lg-12">
              <div class="row mt-2 block_row" v-for="user_project in users" :key="user_project.last_id">
                <div class="col-12 col-sm-6 col-md-4 col-lg-4">
                  <avatar v-if="user_project.avatar==null" :size="187" :username="user_project.name"
                      class="right floated ui image"></avatar>
                  <img style="max-width:30px;" v-if="user_project.avatar"
                      :src="image_url+user_project.avatar"
                      class="right floated"
                  />
                </div>
                <div class="col-12 col-sm-6 col-md-4 col-lg-4">
                  <router-link  tag="a" :to="{name: 'user_page_main', params: { user_id: user_project.last_id }}">{{ user_project.name }}</router-link>
                </div>
                <div class="col-12 col-sm-12 col-md-4 col-lg-4">
                  <p>
                  <b v-if="user_project.role=='client'">Клиент</b>
                  <b v-if="user_project.role=='developer'">Исполнитель</b>
                  <b v-if="user_project.role=='spectator'">Наблюдатель</b>
                  </p>
                  <p><button v-if="user_project.role=='spectator'" class="btn" @click="deleteSpectator(user_project.last_id)">Удалить</button>
                  </p>
                </div>
              </div>
            </div>



            <div class="mt-5 alert alert-danger" v-if="invite_user_is_error==true">
              <p>{{ invite_user_message }}</p>
            </div>


            <div class="row alert " v-if="project.invites.length>0" v-for="invite in project.invites" :key="invite.id">
              <div class="col-md-8">
                <textarea readonly class="form-control col-10">{{base_url}}invite/{{invite.project_id}}/{{ invite.code}}</textarea>
                <br>
                Осталось:{{invite.count}}
              </div>
              <div class="col-md-4">
                <button class="btn" @click="deleteInviteLink(invite.id)">Удалить</button>
              </div>
            </div>

            <div class="row mt-5">
              <div class="form-group col-md-6">
                <label for="exampleUsername22">Количество </label>
                <input type="number" class="form-control" required id="exampleUsername22" v-model="count_invites"
                       placeholder="Количество">
              </div>
              <div class="form-group col-md-6">  <button class="mt-4 btn" @click="createInviteLink()">Создать ссылку</button></div>

            </div>

          </div>
          <template slot="footer">
            <base-button type="secondary" @click="modals.users = false">Закрыть</base-button>

          </template>
        </modal>

    </div>

  </section>


</template>
<script>

import {eventBus, vm} from "@/main";
import wysiwyg from "vue-wysiwyg";
import Modal from "@/components/Modal";
import axios from "axios";
import Vue from "vue";
import Api from "@/models/Api";
import Editorjsrender from "@/models/Editorjsrender.vue";
import vueKanban from 'vue-kanban';
import itemTemplate from '@/components/itemTemplate.vue';
import Tabs from "@/components/Tabs/Tabs";
import BaseNav from "@/components/BaseNav";
import CloseButton from "@/components/CloseButton";
import SimpleFlowchart from 'vue-simple-flowchart';
import 'vue-simple-flowchart/dist/vue-flowchart.css';
import itemMapTemplate from '@/components/itemMapTemplate.vue';
import CommentBlock  from "@/components/Custom/CommentBlock.vue"
import ProjectFormCommentBlock from "@/components/Custom/ProjectFormCommentBlock.vue";
import StatusHistoryProjectBlock from "@/components/Custom/StatusHistoryProjectBlock.vue";
import FormPriceBlock from "@/components/Custom/FormPriceBlock.vue";
import FreelanceBlock from "@/components/Custom/FreelanceBlock.vue";
import ProjectCard from "@/components/Custom/ProjectCard";
import LoadingBlock from "@/components/Custom/LoadingBlock";
import UserCard from "@/components/Custom/UserCard";
import ExportModel from "@/models/ExportModel";
var Avatar = require('vue-avatar')


export default {
  data() {
    var app = this;
    return {
      matrix_bot:null,
      guest_token:null,
      is_load_tasks:false,
      itemTemplate,
      'offer_edit':false,
      is_send_offer:0,
      map_current_descr:"",
      map_current_task:null,
      map_items:[],
      map_item:{},
    data_map:{},
      tasks:[],
      'is_send_comments':{

      },
      'tasks_list':{
       'tasks':null,
       'limit':20,
       'offset':0,
        'count':0,
       'next_offset':0,
      },
      'is_send_comment':0,
      filter_tasks_current_status:null,
      "tasks_table": {
        "current_page": 1,
        "on_page": 10,
        "total": 0,
      },
      "filter_tasks":{
        "q":"",

      },
      current_page:"",
      stages: [],
      count_invites:1,
      current_funnel:null,
      statuses:[],
      'fields':{},
      'form':{
        'fields':{},
      },
      funnel:null,
      blocks: [

      ],
      'searchfields':{},
      "funnels": {},
      item: {},
      items: [

      ],
      "matrix_status":Vue.config.MATRIX_AUTH_ENABLE,

      "invite_user_is_error": false,
      "invite_user_message": null,
      "invite_user": null,
      'modals': {
        'modal0': null,
        'modal_pj_invoices': null,
        'modal_integration_telegram':null,
        'modal_link':null,
        'add': null,
        "users": null,
      },

      "project_subcomment": {},
      "subcomment": {},
      'subcomment_send':{},
      "modal_title": "Добавить работу",
      "editProject": {

        'json': null,

      },
      "new_offer_is_error": false,
      "new_offer_error": null,
      "new_comment_is_error": false,
      "new_comment_error": null,
      "newComment": {
        "comment": null
      },

      "newOffer": {
        "last_id": null,
        "price": null,
        "prepaid_price":0,
        "currency": null,
        "date_end": null,
        "comment": null,
        "type":"one",
      },
      "config": {
        placeholder: 'Распишите задачу как можно подробнее',
        tools: {
          header: require('@editorjs/header'),
          list: {
            class: require('@editorjs/list'),
            inlineToolbar: true,
          },
          "code": require('@editorjs/code'),
          inlineCode: {
            class: require('@editorjs/inline-code'),
            shortcut: 'CMD+SHIFT+M',
          },

          embed: require('@editorjs/embed'),
          linkTool: {
            class: require('@editorjs/link'),
            config: {
              endpoint: Vue.config.API_URL + 'editor/fetchUrl', // Your backend endpoint for url data fetching
            }
          },
          Marker: {
            class: require('@editorjs/marker'),
            shortcut: 'CMD+SHIFT+M',
          },
          table: {
            class: require('@editorjs/table'),
          },
          raw: require('@editorjs/raw'),
          delimiter: require('@editorjs/delimiter'),
          quote: {
            class: require('@editorjs/quote'),
            inlineToolbar: true,
            shortcut: 'CMD+SHIFT+O',
            config: {
              quotePlaceholder: 'Enter a quote',
              captionPlaceholder: 'Quote\'s author',
            },
          },
          image: {
            class: require('@editorjs/image'),
            config: {
              additionalRequestHeaders: {
                "Authorization": 'Bearer ' + app.$store.getters.TOKEN
              },
              endpoints: {
                byFile: Vue.config.API_URL + 'editor/uploadImage', // Your backend file uploader endpoint

              }

            }
          },
          attaches: {
            class: require('@editorjs/attaches'),
            config: {
              endpoint: Vue.config.API_URL + 'editor/uploadFile?api_token=' + app.$store.getters.TOKEN,
            }
          },
          warning: require('@editorjs/warning'),
          paragraph: {
            class: require('@editorjs/paragraph'),
            inlineToolbar: true,
          },
          checklist: {
            class: require('@editorjs/checklist'),
            inlineToolbar: true,
          },
        }
      },

      "type_currencys":[],
      "currencys_title":[],
      "lead":null,
      'is_add_task': false,
      'new_invoice_iserror': false,
      'new_invoice_error': null,
      'project_invoices': {},
      'newInvoice': {},
      'type': 'client',
      'image_url': null,
      'base_url':null,
      "telegram_bot":null,
      'iserror': false,
      'error_message': null,
      'users': null,
      'isclose': false,
      'project': {},
      "blog_category":{},
      'is_load': false,
      "offer_btn_edit": "Отправить",

      'me': null,
      "new_task_developer": null,

      "comments": [],
      'relations_type':null,
      'relations':null,
      'history':[],
      'is_load_new_status':true,
      'newLink':{
        'relation_id':null,
        'task_id':null,
        'title_task':'',
      },
      'new_link_iserror':false,
      'new_link_error':'',
      'links_founded_tasks':null,
      itemMapTemplate,
    }
  },
  computed: {
    isClient() {
      return this.me.last_id === this.project.client_id;
    },
  },
  mounted() {
    var app = this;
    app.is_load=false;
    app.matrix_bot=Vue.config.MATRIX_BOT;




    let id = app.$route.params.id;

    Api.loadProjectNew(id,function(data){
      app.type_currencys=data.currencys;
      app.current_page="project";
      if(data.guest_token){
        app.guest_token=data.guest_token
      }
      app.project = data.project;
      app.relations = data.relations;
      app.history=data.history;
      if(data.lead){
        app.lead=data.lead;
      }

      app.type = data.role;
      if (app.project.edit_offer && app.project.edit_offer.last_id) {
        app.newOffer.comment = app.project.edit_offer.comment;
        app.newOffer.price = app.project.edit_offer.price;
        app.newOffer.currency = app.project.edit_offer.currency;
        app.newOffer.date_end = app.project.edit_offer.date_end;
        app.newOffer.last_id = app.project.edit_offer.last_id;
        app.offer_btn_edit = "Редактировать";
      }else {

        app.newOffer={
          "last_id": null,
          "price": null,
          "type":"one",
          "prepaid_price":0,
          "currency": app.type_currencys[0],
          "date_end": null,
          "comment": null,
        };

      }
      app.me = app.$store.getters.USER;
      app.users = data.users;
      if(app.project.status_row.issearch==0){
        for (const [key, user] of Object.entries(app.users)) {
          if(user.last_id!=app.me.last_id || (user.role=='spectator' && user.isapprove==0)){
            app.newInvoice.user_id=user.last_id;
            break;
          }
        }
        app.newInvoice.currency=app.type_currencys[0];
        app.newInvoice.type="client";
        app.newInvoice.type_pay="one";

      }



      app.image_url = Vue.config.IMAGE_URL;
      app.base_url=Vue.config.BASE_URL_FRONT;
      if(data.telegram_bot){
        app.telegram_bot=data.telegram_bot;
      }


      app.relations_type=data.relations_type;
      if(data.blog_category){

        app.blog_category=data.blog_category;
      }


      // if (data.project_invoices == null) {
      //   app.project_invoices = {};
      // } else {
      //   app.project_invoices = data.project_invoices;
      // }
      // app.newComment.project_id = app.project.last_id;
      // if (app.project.isclose == 0) {
      //   app.isclose = false;
      // } else {
      //   app.isclose = true;
      // }
      app.is_load = true;
    },function(){
      app.$router.push({name:'404'});
    });






    eventBus.$on("update_project_tasks", data => {
      Api.loadProjectFields({},function(data){

        app.current_page="canban";
        app.is_load=true;
        app.fields=data.fields;
        app.searchfields=data.get_vars;

        if(data.statuses.length>0){
          app.statuses=data.statuses;
          var statuses=data.statuses;
          app.stages=[];
          statuses.forEach((element) => {
            app.stages.push(element.title);
          })
          app.blocks=[];
          statuses.forEach((element) => {
            if(element.projects && element.projects.length>0){
              var projects=element.projects;


              projects.forEach((project) => {

                var new_arr={
                  id: project.last_id,
                  status: element.title,
                  title: project.name_project,
                  project:project,
                }
                app.blocks.push(new_arr);
              })
            }

          })

        }
      },id);
      app.changeFilterTasks();

    })
    eventBus.$on("update_project_info", data => {
      app.project.json = data.json;

    })

  },
  methods: {
    async  exportPDF(){


      var app=this;
      var vm=this;
      var title=app.project.name_project;


      var htmlData="<p>Статус:"+app.project.status_row.title+"</p>"+app.$refs.contentArticle.$el.innerHTML;
      if(app.$refs.links_tasks){
        htmlData=htmlData+app.$refs.links_tasks.innerHTML;
      }

      var footerHTML="<p>Проект <a href='"+document.location.href+"'>"+title+"</a></p>";
      if(app.project.main_project_id>0){
        footerHTML="<p>Задача <a href='"+document.location.href+"'>"+title+"</a></p>";

      }


      await ExportModel.start(title,htmlData,footerHTML);

    },
    preventClick(e){


          // Does not prevent route change
          e.preventDefault();
          return false;

    },
   showEditFreelanceBlock(){

     var app=this;
     app.offer_edit=true;
   },
    nextBtnTasksList(){
      var app=this;

      if(app.tasks_list.next_offset>app.tasks_list.offset){
      app.changeFilterTasks(app.tasks_list.next_offset)

      }

    },
    prevBtnTasksList(){
      var app=this;

      var offset=app.tasks_list.offset;
      offset=offset-app.tasks_list.limit;
      if(offset>=0){
        app.changeFilterTasks(offset)
      }

    },
  changeFilterTasks(current_offset=0){
      var app = this;
      var filter={};

      if(Number.isInteger(app.filter_tasks_current_status)){
        filter.status=app.filter_tasks_current_status;
      }
    app.is_load_tasks=false;
      filter.q=app.filter_tasks.q;
      var project_id=app.project.last_id;
      Api.loadTasksWithFilterApiv2(filter,project_id,current_offset,app.tasks_list.limit,function (data) {
        app.tasks = data.tasks;
        app.is_load_tasks=true;
        app.tasks_list.count=data.count;
        app.tasks_list.offset=current_offset;
        app.tasks_list.next_offset=data.offset;


       // app.tasks_table.total = app.tasks.length;
      });

    },
    openCurrentPageProject(){
      var app=this;
      app.current_page="project";
      return false;
    },
    changeManageSpectator(manage_spectator_value=false){
      var app=this;
      var id=app.project.last_id;
      Api.changeManageSpectator(id,manage_spectator_value,function(manage_spectator){

         app.project.manage_spectator=parseInt(manage_spectator);
      },id);

    },
    itemMapSelected (item) {




      var app=this;
      app.map_current_task=item;

    },
    setMapLabel (item) {
      return item.name;
    },
    inputMapChange (text) {
      var app=this;
      // your search method
      app.map_items=[];
      Api.searchTasks(app.project.last_id,text,function(data){
        if(data.tasks.length>0){
          var leads=data.tasks;

          leads.forEach((element) => {
            var name="";
            if(element.name_project){
              name=name+" "+element.name_project;
            }


            name=name+" ["+element.status_row.title+"]";
            var new_element={id:element.last_id,name:name};
            app.map_items.push(new_element);
          })
        }
      });
      // now `items` will be showed in the suggestion list
    },
    openCurrentPageTasks(){
      var app=this;
      var id=app.project.last_id;
      if(app.current_page=="tasks"){
        return false;
      }
      app.current_page="tasks";


      app.changeFilterTasks();
    },
    openCurrentPageMap(){
      var app=this;
      if(app.current_page=="map"){
        return false;
      }
      Api.getMap(app.project.last_id,function(data){


        if(data.map){

          app.data_map=data.map;
          app.current_page="map";
        }
      });


    },
    saveMap(){
      var map=this.data_map;
      var app=this;

      Api.saveMap(app.project.last_id,map,function(data){


        if(data.map){

          app.data_map=data.map;
          app.current_page="map";
        }
      },function(error){

      });
    },
    addTaskOnMap(){

    var current_task=this.map_current_task;
    var current_descr=this.map_current_descr;
    var new_node={};
    new_node.id=current_task.id;
    new_node.x=-700;
    new_node.y=69;
    new_node.type=current_task.name;
    new_node.description=current_descr;
    new_node.label=current_descr;
    var app=this;
    app.data_map.nodes.push(new_node);

    app.map_current_task=null;
    app.map_current_descr="";



    },
    openCurrentPageCanban(){
      var app=this;
      var id=app.project.last_id;
      if(app.current_page=="canban"){
        return false;
      }
      Api.loadProjectFields({},function(data){
        var loaded_vars=data.get_vars;
        var new_vars={};


        Object.keys(loaded_vars).map(function(objectKey, index) {
          var item = loaded_vars[objectKey];
          if(item && item!="null"){
            new_vars[objectKey]=item;
          }else{
            new_vars[objectKey]="";
          }
        });
        app.current_page="canban";
        app.is_load=true;
        app.fields=data.fields;
        app.searchfields=new_vars;

        if(data.statuses.length>0){
          app.statuses=data.statuses;
          var statuses=data.statuses;
          app.stages=[];
          statuses.forEach((element) => {
            app.stages.push(element.title);
          })
          app.blocks=[];
          statuses.forEach((element) => {
            if(element.projects && element.projects.length>0){
              var projects=element.projects;


              projects.forEach((project) => {

                var new_arr={
                  id: project.last_id,
                  status: element.title,
                  title: project.name_project,
                  project:project,
                }
                app.blocks.push(new_arr);
              })
            }

          })

        }
      },id);
    },
    callModelEditLead(lead){
      var app=this;
      var params = {
        "lead_id": lead.id,
        type: "editlead",
        modal_title: "Редактирование лида",
        json:lead.project_data
      };
      eventBus.$emit("call_modal_add_project", params)
      {


      }
    },
    updateBlock(id, status) {
      var app=this;

      var statuses=app.statuses;
      var new_status=null;
      statuses.forEach((element) => {
        if(element.title==status){
          new_status=element;
        }

      })
      if(new_status!=null){
        var app=this;
        var lead_id=id;

        var  json={

          "status_id":new_status.last_id,

        }

        Api.setNewStatus(new_status.last_id, id, function (data) {


          if(data.type=="error"){
            alert(data.message);
          }

        });
      }
      return false;

      //this.blocks.find(b => b.id === Number(id)).status = status;
    },

    itemSelected (item) {
      this.item = item;
      var app=this;
      app.$router.push({name: 'lead', params: {id: item.id, "rand": Math.random()}});
    },
    clickElementMap(){
    alert('clickoff');
    return false;
    },
    setLabel (item) {
      return item.name;
    },
    inputChange (text) {
      var app=this;
      // your search method
      app.items=[];
      Api.searchLead(text,function(data){
        if(data.leads.length>0){
          var leads=data.leads;

          leads.forEach((element) => {
            var name="";
            if(element.lead_data.name){
              name=name+" "+element.lead_data.name;
            }
            if(element.lead_data.phone){
              name=name+" "+element.lead_data.phone;
            }
            if(element.lead_data.email){
              name=name+" "+element.lead_data.email;
            }
            name=name+" "+element.funnel.title+"/"+element.status.title;
            var new_element={id:element.id,name:name};
            app.items.push(new_element);
          })
        }
      });
      // now `items` will be showed in the suggestion list
    },
    callModalAddLead() {
      var app=this;
      var params = {

        type: "addlead",
        islead: true,
        funnel_id:app.current_funnel,

        modal_title: "Добавление лида",

        json: {
          "blocks": [{
            "type": "header",
            "data": {
              "text": "Безымянный проект",
              "level": 2
            }
          }]
        }
      };
      eventBus.$emit("call_modal_add_project", params)
      {


      }
    },
    searchFilter(){
      var app=this;
      var filter=this.searchfields;
      app.is_load=false;



      Api.loadSaveProjectFields(filter,function(data){
        var loaded_vars=data.get_vars;
        var new_vars={};


        Object.keys(loaded_vars).map(function(objectKey, index) {
          var item = loaded_vars[objectKey];
          if(item && item!="null"){
            new_vars[objectKey]=item;
          }else{
            new_vars[objectKey]="";
          }
        });
        app.is_load=true;
        app.stages.length=0;

        app.stages=[];
        app.blocks.length=0;
        app.blocks=[];
        app.statuses.length=0;
        app.statuses=[];
        //     while( app.stages.length > 0) { app.stages.length.pop();}
        //      while( app.blocks.length > 0) { app.blocks.length.pop();}
        //    while( app.statuses.length > 0) { app.statuses.length.pop();}


        app.fields=data.fields;

        app.searchfields=new_vars;


        if(data.statuses.length>0){
          app.statuses=data.statuses;
          var statuses=data.statuses;
          statuses.forEach((element) => {
            app.stages.push(element.title);
          })
          statuses.forEach((element) => {
            if(element.projects && element.projects.length>0){
              var projects=element.projects;

              projects.forEach((project) => {

                var new_arr={
                  id: project.last_id,
                  status: element.title,
                  title: project.name_project,
                  project:project,
                }
                app.blocks.push(new_arr);
              })
            }
          })

        }
      },app.project.last_id)
    },
    openLead(lead_id){
      var app=this;

      let routeData = app.$router.resolve({name: 'lead',params: {id: lead_id, "rand": Math.random()}});
      window.open(routeData.href, '_blank');
    },
    openProject(lead_id){
      var app=this;

      let routeData = app.$router.resolve({name: 'project',params: {id: lead_id, "rand": Math.random()}});
      window.open(routeData.href, '_blank');
    },
    deleteSpectator(user_id) {
      var app = this;
      Api.deleteSpectator(app.project.last_id, user_id, function (users) {


        app.users = users;
      }, function (message) {

      });
    },
    deleteInviteLink(invite_id){
     var app=this;
     Api.deleteInviteLink(app.project.last_id,invite_id,function(invites){
       app.project.invites=invites;
     },function(error){

     });
    },
    createInviteLink(){
      var app=this;
      Api.createInviteLinkforProject(app.project.last_id,app.count_invites,function(invites){

        app.project.invites=invites;


      },function(error){

      })
    },
    inviteUser() {
      var app = this;
      Api.addUser(app.project.last_id, app.invite_user, function (users) {

        app.invite_user_is_error = false;
        app.invite_user = null;
        app.users = users;
      }, function (message) {
        app.invite_user_is_error = true;
        app.invite_user_message = message;
      });
    },
    addTaskClick() {

      var params = {
        "project_id": this.project.last_id,
        "project":this.project,
        type: "addtask",
        type_user: this.type,
        modal_title: "Добавить задачу",
        users: this.users,
        json: {
          "blocks": [{
            "type": "header",
            "data": {
              "text": "Название задачи вашей мечты!",
              "level": 2
            }
          }]
        }
      };

      eventBus.$emit("call_modal_add_project", params)
      {


      }


    },
    editProjectShareClick(){
      var app=this;
      var params = {
        "project_id": this.project.last_id,
        'project':this.project,
        type: "edit",
        modal_title: "Редактирование задачи",

        json: this.project.json
      };
      eventBus.$emit("call_modal_add_project", params)
      {


      }
    },
    editProjectClick() {
      var params = {
        "project_id": this.project.last_id,
        'project':this.project,
        type: "edit",
        modal_title: "Редактирование проекта",
        json: this.project.json
      };
      eventBus.$emit("call_modal_add_project", params)
      {


      }
      // this.$refs.editor._data.state.editor.render(this.project.json);
      // app.is_add_task = false;
      // this.modal_title = "Редактирование проекта";
      // this.modals.add = true;
    },
    ChooseOffer(offer_id) {
      var app = this;
      Api.chooseOfferProject(app.project.last_id, offer_id, function (project) {
        document.location.reload();
        //app.$router.replace({"name": "project", "params": {"id": project.last_id, "rand": Math.random()}});
        // this.$router.push({"name": "project", "params": {"id": button.params.id, "rand": Math.random()}});
        //vm.$forceUpdate();
      });
    },
    removeLink(relation_id){
      var app=this;
      var project_id = app.project.last_id;
      Api.removeTaskLink(project_id, relation_id, function (data) {

        app.relations = data.relations;
        //eventBus.$emit('is_load_project', data);
        //app.modals.modal_link = false;
      })
    },
    searchTasksLink(){
      var app=this;
      var linkData=app.newLink;
      var q=linkData.title_task;
      var filter={};
      filter.q=q;
      var project_id=app.project.main_project.last_id;
      Api.loadTasksWithFilterApiv2(filter,project_id,0,10,function (data) {
        app.links_founded_tasks = data.tasks;



        // app.tasks_table.total = app.tasks.length;
      });
    },
    insertTaskIdToLink(task_id){
      var app=this;

      app.newLink.task_id=task_id;
    },
    addLink(){
      var app=this;
      var linkData=app.newLink;
      var project_id = app.project.last_id;
      Api.addTaskLink(project_id, linkData, function (data) {
        app.new_link_iserror = false;

        app.newLink = {};
        app.relations = data.relations;
        //eventBus.$emit('is_load_project', data);
        app.modals.modal_link = false;
      }, function (message) {
        app.new_link_iserror = true;
        app.new_link_error = message;
      })

    },
    addInvoice() {
      var app = this;
      var project_id = app.project.last_id;
      var newInvoice = app.newInvoice;
      Api.addProjectInvoice(project_id, newInvoice, function (data) {
        app.new_invoice_iserror = false;

        app.newInvoice = {};
        app.project = data.project;
        //eventBus.$emit('is_load_project', data);
        app.modals.modal0 = false;
      }, function (message) {
        app.new_invoice_iserror = true;
        app.new_invoice_error = message;
      })


    },
    doEditProject() {
      var app = this;

      this.$refs.editor._data.state.editor.save()
          .then((data) => {
            // Do what you want with the data here
            var edit_project = {"last_id": app.project.last_id, "json": data};

            if (app.is_add_task == true) {
              edit_project.developer = app.new_task_developer;
              Api.addTask(edit_project, function (tasks) {
                app.iserror = false;

                app.modals.add = false;
                app.is_add_task = false;
                app.project.tasks = tasks;

                app.$refs.editor._data.state.editor.clear();

              }, function (message) {
                app.iserror = true;
                app.error_message = message;
              })
            } else {
              Api.editProject(edit_project, function () {
                app.iserror = false;

                app.modals.add = false;
                app.project.json = edit_project.json;
                app.$refs.editor._data.state.editor.clear();

              }, function (message) {
                app.iserror = true;
                app.error_message = message;
              })
            }


          })
          .catch(err => {

          })
    },
    sendOfferComment(offer_id, index,comment_text) {
      var app = this;

      app.subcomment_send['offer'+offer_id]=1;
      var comment = comment_text;
      Api.sendOfferComment(app.project.last_id, offer_id, comment, function (comments) {
        var offers=app.project.offers;

        offers[index].comments = comments;
        app.$set(app.project,"offers",offers);
        app.$set(app.subcomment_send,'offer'+offer_id,0);
        app.$set(app.subcomment,'offer' + offer_id,"");


      });

    },

    sendOffer() {
      var app = this;
      app.newOffer.project_id = this.project.last_id;
      app.is_send_offer=1;
      Api.sendOffer(app.newOffer, function (offer) {
        app.is_send_offer=0;
        app.new_invoice_iserror = false;
        if (app.newOffer.last_id == null) {
          app.project.offers = app.project.offers.concat([offer]);
          app.newOffer.last_id = offer.last_id;
          app.offer_edit=false;
        } else {


          const index = app.project.offers.findIndex(item => {
            return (offer.last_id === item.last_id)
          })
          app.project.offers.splice(index, 1, offer)

        }


        app.offer_btn_edit = "Отредактировать";

      }, function (message) {
        app.is_send_offer=0;
        app.new_invoice_iserror = true;
        app.new_invoice_error = message;
      })

    },
    sendSubComment(comment_id, comment_index) {
      var app = this;

      app.is_send_comments['comment_'+comment_id]=1;
      var comment = app.project_subcomment['comment' + comment_id];
      Api.sendSubComment(app.project.last_id, comment_id, comment, function (comments) {
        app.history[comment_index].comments = comments;
        app.project_subcomment['comment' + comment_id] = "";
        app.is_send_comments['comment_'+comment_id]=0;

      });
    },
    openTask(task_id) {

      window.location= "/project/" + task_id;
      this.$route.params.id = task_id;
      Api.loadProject(task_id);
    },
    setNewStatus() {
      var app = this;
      app.is_load_new_status=false;

      var status = app.project.status;
      Api.setNewStatus(status, app.project.last_id, function () {
      app.is_load_new_status=true;
      });
    },
    sendComment(event) {
   //   event.preventDefault();
      var app = this;
      var newComment = app.newComment;
      Api.addComment(newComment, app.project.last_id, function (result_comment) {
        app.iserror = false;

        app.newComment.comment = "";
        app.history.push(result_comment)
      }, function (message) {
        app.iserror = true;
        app.error_message = message;
      })


    },
  },
  components: {
    SimpleFlowchart,
    UserCard,
    Modal, 'editorjsrender': Editorjsrender,
    'avatar': Avatar.Avatar,
    'CommentBlock':CommentBlock,
    'FormPriceBlock':FormPriceBlock,
    'FreelanceBlock':FreelanceBlock,
    'FormCommentBlock':ProjectFormCommentBlock,
    'StatusHistoryProjectBlock':StatusHistoryProjectBlock,
    Tabs,BaseNav,CloseButton,'ProjectCard':ProjectCard, LoadingBlock
  }
};
</script>
<style>
</style>
